const JSON_BLOB_PREVIEW_BYTES = 512

export const isJsonBlob = async (blob: Blob) => {
  if (blob.type.includes('json')) {
    return true
  }

  const preview = (await blob.slice(0, JSON_BLOB_PREVIEW_BYTES).text()).trim()
  return preview.startsWith('{') || preview.startsWith('[')
}
